<template>
	<div class="products__container" v-cloak>
		<div class="products__most-used"></div>
		<div class="container">
            <div class="row">
                <div v-if="windowWidth > 991" class="products__sidebar col-lg-3">
                    <div class="products__sidebar-top">
                        <div class="products__sidebar-toggle" @click="showFilters()" :class="{ 'products__sidebar-toggle--open' : filtersMobileOpen }">
                            Filters
                        </div>
                    </div>
                    <div class="products__sidebar-outer" :class="{ 'products__sidebar-outer--open' : filtersMobileOpen }">
                        <div class="products__sidebar-inner">
                            <SideFilters></SideFilters>
                        </div>
                    </div>
                </div>
                <div class="products__products col-lg-9">
                    <div id="products__scrollto-container"></div>
<!--                                <div class="products__products-tax">-->
<!--                            <TopFilter :taxonomy="setFilterTaxonomy()" @tax-updated="topFilterUpdated"></TopFilter>-->
<!--                                </div>-->
                    <div id="products__cat-append-wrapper" class="products__cat-append-wrapper"></div>
                    <div v-if="windowWidth < 991" class="products__mobile-sidefilter">
                        <div class="products__sidebar-top">
                            <div class="products__sidebar-toggle" @click="showFilters()" :class="{ 'products__sidebar-toggle--open' : filtersMobileOpen }">
                                Filters
                            </div>
                        </div>
                        <div class="products__sidebar-outer" :class="{ 'products__sidebar-outer--open' : filtersMobileOpen }">
                            <div class="products__sidebar-inner">
                                <SideFilters></SideFilters>
                            </div>
                        </div>
                    </div>
                    <div class="products__grid-top">
                        <div class="products__count">
                            <span v-if="products.loading == true">- </span>
                            <span v-if="products.loading == false">{{ products.headers.totalItems }} </span>
                            <span v-if="language === 'de'">suchergebnisse</span>
                            <span v-if="language === 'nl'">resultaten</span>
                            <span v-if="language === 'en'">search results</span>
                        </div>
                        <div class="products__grid-top-right">
                            <div class="products__photo-type">
                                <div @click="products.photoType = 'product'" class="products__photo" :class="{ 'products__photo--active' : products.photoType == 'product' }">Productfoto's</div>
                                <div @click="products.photoType = 'ambiance'" class="products__photo" :class="{ 'products__photo--active' : products.photoType == 'ambiance' }">Sfeerfoto's</div>
                            </div>
                            <div class="products__order">
                                <div class="products__order-label" v-if="language === 'nl'">Sorteren op</div>
                                <div class="products__order-label" v-if="language === 'de'">Sortieren nach</div>
                                <div class="products__order-label" v-if="language === 'en'">Sort by</div>
                                <select name="order" id="order" v-model="order.set.id" @change="loadPosts()">
                                    <option v-for="option in order.items" :value="option.id">{{ option.label }}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div class="products__grid">
                        <div :class="{ 'products__loader--loading' : products.loading }" class="products__loader">
                            <img v-bind:src="loaderSvgUrl" />
                        </div>
                        <div :class="{ 'products__outer--loading' : products.loading }" class="products__outer">
                            <template v-for="(item, index) in products.items">
                                <div class="tile tile--is-product tile--in-grid" :key="item.id">
                                    <div class="tile__inner">
                                        <a :href="item.link" class="tile__image-container" :class="{ 'tile__image-container--product' : products.photoType == 'product' }">
                                            <img class="tile__image" v-if="item.acf.product_tile_image && products.photoType == 'product'" :src="item.acf.product_tile_image.sizes.woocommerce_thumbnail" :alt="item.title.rendered" width="300" :height="item.acf.product_tile_image.sizes.woocommerce_thumbnail_height" />
                                            <img class="tile__image tile__image--ambiance" v-if="item.featured_image_url && products.photoType == 'ambiance'" :src="item.featured_image_url" :alt="item.title.rendered" width="315" height="315" />
                                            <img class="tile__image tile__image--ambiance-hover" :src="item.featured_image_url" :alt="item.title.rendered" width="315" height="315" />
                                        </a>

                                        <span class="tile__content">
                                            <div class="tile__content-top">
                                                <span class="tile__title" v-if="item.title" v-html="item.title.rendered"></span>
                                                <span class="tile__price" v-if="item.meta._price" v-html="generatePrice(item.meta._price)"></span>
                                            </div>

                                            <div class="tile__buttons">
                                                <a :href="item.link" class="button button--green-l button--small button--in-tile">{{ products.seeButtonLabel }}</a>
                                                <a :href="item.acf['3d_configurator_url_overwrite']" v-if="item.acf['3d_configurator_url_overwrite']" rel="nofollow noopener" target="_blank" class="button button--green-d button--small button--in-tile">{{ products.configuratorButtonLabel }}</a>
												<a :href="'https://woodpro-configurator.nl/code/' + item.acf['3d_configurator']" v-if="item.acf['3d_configurator'] && language === 'nl' && !item.acf['3d_configurator_url_overwrite']" rel="nofollow noopener" target="_blank" class="button button--green-d button--small button--in-tile">{{ products.configuratorButtonLabel }}</a>
                                                <a :href="'https://woodpro-konfigurator.de/3D/' + item.acf['3d_configurator']" v-if="item.acf['3d_configurator'] && language === 'de' && !item.acf['3d_configurator_url_overwrite']" rel="nofollow noopener" target="_blank" class="button button--green-d button--small button--in-tile">{{ products.configuratorButtonLabel }}</a>
                                                <a :href="'https://woodpro-configurator.com/3D/' + item.acf['3d_configurator']" v-if="item.acf['3d_configurator'] && language === 'en'  && !item.acf['3d_configurator_url_overwrite']" rel="nofollow noopener" target="_blank" class="button button--green-d button--small button--in-tile">{{ products.configuratorButtonLabel }}</a>
                                            </div>
                                        </span>
                                    </div>
                                </div>

                                <!-- START CTA CARD INSIDE GRID -->
<!--                                <div v-if="index === 6" class="tile tile&#45;&#45;is-product tile&#45;&#45;in-grid tile&#45;&#45;orange">-->
<!--                                    <div class="tile__inner">-->
<!--                                    <span class="tile__content tile__content&#45;&#45;orange d-grid align-items-center justify-content-center">-->
<!--                                        <div>-->
<!--                                            <h3 class="tile__title&#45;&#45;orange">{{ products.orangeTileTitle }}</h3>-->
<!--                                        <p class="tile__description">{{ products.tileText }}</p>-->
<!--                                        </div>-->
<!--                                        <a href="/3d-configurator/" rel="nofollow" class="button button&#45;&#45;orange-d button&#45;&#45;large button&#45;&#45;in-tile">{{ products.orangeTileBtn }}</a>-->
<!--                                    </span>-->
<!--                                    </div>-->
<!--                                </div>-->
                                <!-- END CTA CARD INSIDE GRID -->

                            </template>
                        </div>
                    </div>
                    <div class="products__pagination-container">
                        <pagination v-model="products.pagination.page" :records="products.headers.totalItems" :per-page="18" @paginate="paginate()" :options="products.pagination.options" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Pagination from 'vue-pagination-2';
import setLanguage from './mixins/setLanguage';
import determineLanguage from './mixins/determineLanguage';
import SideFilters from './SideFilters';
import EventBus from './mixins/eventBus';
import numberFormatter from 'number-formatter';
import MyPagination from './Pagination'
import TopFilter from './TopFilter';
import setCanonicals from './mixins/setCanonicals';
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

export default {
	data() {
		return {
			products: {
				headers: {
					totalItems: 1,
					totalPages: 1
				},
				pagination: {
					page: 1,
					options: {
						edgeNavigation: false,
						theme: 'bootstrap4',
						chunk: 10,
						chunksNavigation: 'fixed',
						template: MyPagination,
						texts: {
							nextPage: 'Volgende',
							prevPage: 'Vorige',
							nextChunk: '>>',
							prevChunk: '<<'
						}
					}
				},
				items: [],
				itemIds: [],
				loading: true,
				perPage: 18,
				seeButtonLabel: 'Bekijken',
				threeDButtonLabel: 'Aanpassen in 3D',
				photoType: 'ambiance'
			},
			ctaTile: {
				dataFilled: false,
				enabled: false,
				imageUrl: String,
				text: String,
				buttonUrl: String,
				buttonText: String
			},
			filterState: false,
			postType: '',
			baseUrl: '',
			language: '',
			initialPageLoad: true,
			filtersMobileOpen: false,
            categoriesPlaced: false,
            api: null,
			paramFromFilter: {
				filterParameters: '',
				page: 1
			},
			order: {
				set: {
					id: 0,
					// type: 'orderby',
					// value: 'date',
					// label: 'Willekeurig'
				},
				items: [
                    {
                        id: 0,
                        type: 'orderby',
                        value: 'menu_order',
                        label: 'Populariteit',
                        order: 'asc'
                    },
					{
						id: 1,
						type: 'order_price',
						value: 'up',
						label: 'Prijs laag - hoog'
					},
					{
						id: 2,
						type: 'order_price',
						value: 'down',
						label: 'Prijs hoog - laag'
					},
				],
			},
			errors: [],
            windowWidth: window.innerWidth,
            loaderSvgUrl: null
		}
	},
	mixins: [setLanguage, determineLanguage, setCanonicals],
	created() {
		this.setBaseUrl();
		this.language = this.setLanguage();
		this.postType = this.setPostType();
        this.getLoaderSvg();
        this.setLanguageLabels();
        this.setPaginationFromParam();
		this.loadPosts();
	},
    components: {
		Pagination,
        TopFilter,
		SideFilters
    },
	mounted() {
		EventBus.$on('UPDATE_PRODUCTS', data => {
			if (data.filterParameters !== null) {
				this.paramFromFilter.filterParameters = data.filterParameters;
			} else {
				this.paramFromFilter.filterParameters = null;
			}
			this.paramFromFilter.page = data.page;
			this.loadPosts();
		});
		EventBus.$on('PAGE_LOAD_ATTR_COUNT', data => {
			if (window.location.hash) {
				let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', ''));
				this.loadAllProductIDs(null, onLoadParameters);
			} else {
				this.loadAllProductIDs();
			}
		});
	},
    updated: function() {
        this.placeCategories();
    },
	methods: {
		loadPosts() {
			let _this = this;

			// Fetch posts
			let pageProducts = function pageProducts() {
				let fetchUrl = _this.fetchUrl();

				// Catch and add parametes from URL if they exists (only on pageload)
				if (_this.initialPageLoad == true && window.location.hash && window.location.hash.includes('#!/&')) {
					let onLoadParameters = decodeURIComponent(window.location.hash.replace('#!/', ''));
					_this.paramFromFilter.filterParameters = onLoadParameters;
				}

				// Add parameters from filter is they exists
				if (_this.paramFromFilter.filterParameters !== null) {
					_this.products.loading = true;

					if (_this.paramFromFilter.filterParameters !== null) {
						fetchUrl += _this.paramFromFilter.filterParameters;

						// Update count for all terms (within this if statement because we only want to run it on a filter action, not on pageload (because we already have that data))
						_this.loadAllProductIDs(_this.paramFromFilter);
					}
				} else {
					_this.loadAllProductIDs();
				}

				// Add sort parameter
				if (_this.order.set) {
					_this.products.loading = true;

					// Set order by URL Param on page load
					if (_this.initialPageLoad == true) {
						if (window.location.hash.includes('order_price=up')) {
							_this.order.set.id = 1;
						} else if (window.location.hash.includes('order_price=down')) {
							_this.order.set.id = 2;
						}
					}


                    let settedOrder = _this.order.set.id;
                    let orderParam = '&' + _this.order.items[settedOrder]['type'] + '=' +_this.order.items[settedOrder]['value'];

                    if (_this.order.items[settedOrder]['order']) {
                        orderParam += '&order=' + _this.order.items[settedOrder]['order']
                    }

                    fetchUrl = fetchUrl + orderParam;

					// Add sort parameter to URL in addressbar
					let curHash = window.location.hash;

					if (_this.order.set.id !== 0) {
						window.location.hash = window.location.hash.replace('&order_price=up', '').replace('&order_price=down', '').replace('&orderby=date', '');
						window.location.hash += orderParam;
					} else if (_this.order.set.id == 0) {
						window.location.hash = window.location.hash.replace('&order_price=up', '').replace('&order_price=down', '').replace('&orderby=date', '');
					}
				}

				return axios.get(fetchUrl)
				.then(response => {
					// Set 'headers' meta data
					_this.products.headers.totalItems = parseInt(response.headers['x-wp-total']);
					_this.products.headers.totalPages = parseInt(response.headers['x-wp-totalpages']);

					// Set posts to local data
					_this.products.items = response.data;

                    // Set canonical, next and prev url in <head>
                    if (_this.initialPageLoad === true) {
                        _this.setCanonicals(_this.products.pagination.page, _this.products.headers.totalPages);
                    }

					_this.initialPageLoad = false;
                })
				.catch(e => {
					_this.errors.push(e);
				});
			}

			let axiosQueue = [pageProducts()];
			if (axiosQueue) {
				return Promise.all(axiosQueue)
				.then(function (v) {
					// Disable loading
					_this.products.loading = false;

					// Insert CTA tile at fifth position if exists and on first page and no filter is set
					if (_this.ctaTile.enabled && _this.products.pagination.page == 1 && _this.filterState == false) {
						let ctaTileObj = _this.ctaTile;
						_this.products.items.splice(4, 0, ctaTileObj);
					}
				})
				.catch(function(e) {
					console.error('Promise all error', e);
				});
			}
		},

        setPaginationFromParam() {
            let _this = this;
            if (_this.initialPageLoad == true) {
                let queryString = decodeURIComponent(window.location.hash.replace('#!/', ''));
                queryString = '?' + queryString.substring(1);
                let urlParams = new URLSearchParams(queryString);
                if (urlParams.get('page') !== null) {
                    let pageParam = parseInt(urlParams.get('page'));
                    if (pageParam) {
                        _this.products.pagination.page = pageParam;
                    }
                }
            }
        },

        removeParam(key, sourceURL) {
            var rtn = sourceURL,
                param,
                params_arr = [],
                queryString = sourceURL;
            if (queryString !== "") {
                params_arr = queryString.split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    param = params_arr[i].split("=")[0];
                    if (param === key) {
                        params_arr.splice(i, 1);
                    }
                }
                if (params_arr.length) rtn = params_arr.join("&");
            }
            return rtn;
        },

        setFilterTaxonomy() {
            let postEl = document.getElementById('products');
            let postCat = null;
            if (postEl) {
                postCat = postEl.getAttribute('data-tax');
            }
            if (postCat) {
                return postCat;
            }
        },

		// We need to have an array with all product ids to get the number of posts in each attribute in the wp_term_relationships table
		loadAllProductIDs(filterParameters = null, onLoadParameters = null) {
			let _this = this;

			// create REST URL with all posts
			let fetchUrl = _this.fetchUrl(true);

			if (filterParameters !== null) {
				if (filterParameters.filterParameters !== null) {
					fetchUrl += filterParameters.filterParameters;
				}
			}

			if (onLoadParameters !== null) {
				fetchUrl += onLoadParameters;

			}

			return axios.get(fetchUrl)
			.then(response => {
				// Set post IDs to local data
				let arrIDsOnly = [];
				response.data.forEach((item) => {
					arrIDsOnly.push(item.id);
				})

				_this.products.itemIds = arrIDsOnly;

				// We now have all product ids so we can use our custom ajax request to get a list of all terms with the count
				_this.updateAttrCount();
            })
			.catch(e => {
				_this.errors.push(e);
			});
		},

		// Fetch term_id of all terms and the product count of it
		updateAttrCount() {
			let _this = this;

			let allProductIds = _this.products.itemIds;
			allProductIds = allProductIds.join();

			let fetchUrl = window.location.origin + '/wp-json/attributes_count/v1/attr/ids=' + allProductIds;

            if (window.location.origin.includes('test')) {
                fetchUrl = window.location.origin + '/' + _this.language + '/wp-json/attributes_count/v1/attr/ids=' + allProductIds;
            }

			let allFilterEls = document.querySelectorAll('[data-slug]');
			allFilterEls.forEach((filterEl) => {
				filterEl.textContent = '(-)';
				filterEl.parentElement.parentElement.classList.add('filter__checkbox--no-click');
			})

			return axios.get(fetchUrl)
			.then(response => {
				let results = response.data;

				let forCount = 0;
				for (const item in results) {
					let filterEl = document.querySelectorAll('[data-slug="'+item+'"]');

					if (filterEl.length > 0) {
						filterEl[0].textContent = '('+results[item]+')';

						if (results[item] == 0) {
							filterEl[0].parentElement.parentElement.classList.add('filter__checkbox--disabled');
						} else {
							filterEl[0].parentElement.parentElement.classList.remove('filter__checkbox--disabled');
							filterEl[0].parentElement.parentElement.classList.remove('filter__checkbox--no-click');
						}
					}

					forCount++;
				}
            })
			.catch(e => {
                console.error('%c updateAttrCount() => '+ e , 'color: #ff0000');
			});
		},

		// Reset attr count to its original value (meaning no filter is selected)
		resetAttrCount() {
			EventBus.$emit('RESET_ATTR_COUNT');
		},

		// Create REST API URL which can be used in an Axios call
		fetchUrl(allPostIds = false) {
            let _this = this;
			// Set posts per page
			let perPage = (this.ctaTile.enabled && this.products.pagination.page == 1) ? 17 : this.products.perPage;

            // perPage = (this.products.pagination.page == 1) ? 16 : this.products.perPage;

			// Set page number
			let pageNumber = '&page=' + this.products.pagination.page;

			let postType = this.postType;

			let fetchUrl = window.location.origin + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber;
            if (window.location.origin.includes('test')) {
                fetchUrl = window.location.origin + '/' + _this.language + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber;
            }

			// Create a REST API url with WooCommerce category for taxonomy pages
			const body = document.querySelector('body');
			if (body.classList.contains('tax-product_cat')) {
				const vueContainer = document.getElementById('products');
				const termId = vueContainer.dataset.termid;
				if (termId) {
					let termIdParam = '&product_cat=' + termId;

					fetchUrl = window.location.origin + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber + termIdParam;
                    if (window.location.origin.includes('test')) {
                        fetchUrl = window.location.origin + '/' + _this.language + '/wp-json/wp/v2/' + postType + '?per_page=' + perPage + pageNumber + termIdParam;
                    }
				}
			}

			// Create a REST API url with all post-ids only
			if (allPostIds == true) {
				fetchUrl = window.location.origin + '/wp-json/wp/v2/' + postType + '?_fields=id&per_page=299';
                if (window.location.origin.includes('test')) {
                    fetchUrl = window.location.origin + '/' + _this.language + '/wp-json/wp/v2/' + postType + '?_fields=id&per_page=299';
                }

				// Create a REST API url with WooCommerce category for taxonomy pages
				const body = document.querySelector('body');
				if (body.classList.contains('tax-product_cat')) {
					const vueContainer = document.getElementById('products');
					const termId = vueContainer.dataset.termid;
					if (termId) {
						let termIdParam = '&product_cat=' + termId;

						fetchUrl = window.location.origin + '/wp-json/wp/v2/' + postType + '?_fields=id&per_page=299' + termIdParam;
                        if (window.location.origin.includes('test')) {
                            fetchUrl = window.location.origin + '/' + _this.language + '/wp-json/wp/v2/' + postType + '?_fields=id&per_page=299' + termIdParam;
                        }
					}
				}
			}

			return fetchUrl;
		},

		setPostType() {
			let postEl = document.getElementById('products');
			let postType = null;
			if (postEl) {
				postType = postEl.getAttribute('data-posttype');
			}
			if (postType) {
				return postType;
			}
		},

		setBaseUrl() {
			this.baseUrl = window.location.origin;
		},

        paginate() {
            this.products.loading = true;
            EventBus.$emit('UPDATE_PRODUCTS_BY_PAGINATION', this.products.pagination.page);
            setTimeout(function() {
                document.getElementById('products__scrollto-container').scrollIntoView({
                    behavior: 'smooth'
                });
            }, 300);
        },

		generatePrice(price) {
            let _this = this;

			if (price.includes('.')) {
				if (this.language == 'en') {
                    return numberFormatter('£ #.###,#0' ,price);
                } else {
                    return numberFormatter('€ #.###,#0' ,price);
                }
			} else {
				if (this.language == 'en') {
                    return numberFormatter('£ #.###,#0' ,price);
                } else {
                    return numberFormatter('€ #.###,#0' ,price);
                }
			}
		},

        placeCategories() {
            let _this = this;
            let catsWrapperEl = document.getElementById('products__cat-wrapper-el');
            let catsAppendWrapperEl = document.getElementById('products__cat-append-wrapper');

            if (this.categoriesPlaced === false && catsWrapperEl !== null) {
                catsAppendWrapperEl.append(catsWrapperEl)
                _this.categoriesPlaced = true;
            }
        },

		showFilters() {
			this.filtersMobileOpen = !this.filtersMobileOpen;
		},
        setLanguageLabels() {
            let _this = this;
            _this.order.items[0]['label'] = _this.determineLanguage({nl: 'Populariteit', en: 'Popularity', de:'Popularität'});

            _this.order.items[1]['label'] = _this.determineLanguage({nl: 'Prijs laag - hoog', en: 'low to high', de:'niedrigster Preis'});

            _this.order.items[2]['label'] = _this.determineLanguage({nl: 'Prijs hoog - laag', en: 'high to low', de:'höchster Preis'});

            _this.products.seeButtonLabel = _this.determineLanguage({nl: 'Bekijken', en: 'View product', de: 'Zum Artikel'});

            _this.products.configuratorButtonLabel = _this.determineLanguage({nl: '3D configurator', en: '3D configurator', de: '3D Konfigurator'});

            _this.products.orangeTileBtn = _this.determineLanguage({nl: 'Ontdek de 3D configurator', en: 'Discover the 3D configurator', de: '\n' + 'Entdecken Sie den 3D-Konfigurator'});

            _this.products.tileText = _this.determineLanguage({nl: 'Start meteen in onze 3D configurator om een ontwerp te maken!', en: 'Start immediately in our 3D configurator to make a design!', de: '\n' + '\n' + 'Starten Sie sofort in unserem 3D-Konfigurator mit der Gestaltung!'});

            _this.products.orangeTileTitle = _this.determineLanguage({nl: 'Niet gevonden wat u zocht?', en: '\n' + 'Did you not find what you were looking for?', de: '\n' + 'Haben Sie nicht gefunden, wonach Sie gesucht haben?'});

            _this.products.threeDButtonLabel = _this.determineLanguage({nl: 'Aanpassen in 3D', en: 'Design your own garden building', de: 'Selbst konfigurieren'});
        },
        getLoaderSvg() {
            let loaderPath = '/wp-content/themes/woodpro/src/svg/loader.svg';

            if(window.location.origin.includes('woodpro.dev')) {
                loaderPath = '/app/themes/woodpro/src/svg/loader.svg';
            }

            this.loaderSvgUrl = this.baseUrl + loaderPath;
        }
	}
}

</script>
